/* Bulle Tidio a gauche.
   Tidio vit dans un shadow DOM : aucune feuille de style du theme ne peut
   l'atteindre, on injecte donc la regle dans son shadow root. Tidio connait
   deja la position gauche, on ne fait que basculer sa classe de grille.
   Le reglage durable reste celui du tableau de bord Tidio (Apparence >
   Position) ; ceci ne fait que l'appliquer cote site. */
(function () {
  var REGLE = '.grid-layout.widget-position-right{left:0 !important;right:auto !important}';

  function placer() {
    var c = document.getElementById('tidio-chat');
    if (!c || !c.shadowRoot) return false;
    if (c.shadowRoot.getElementById('cd-tidio-gauche')) return true;
    var st = document.createElement('style');
    st.id = 'cd-tidio-gauche';
    st.textContent = REGLE;
    c.shadowRoot.appendChild(st);
    return true;
  }

  if (placer()) return;
  var essais = 0;
  var t = setInterval(function () {
    if (placer() || ++essais > 40) clearInterval(t);
  }, 500);
})();
